// extracted by mini-css-extract-plugin
module.exports = {"numberItem":"requirementsimplified_numberItem__12BWY","descriptionItem":"requirementsimplified_descriptionItem__31fiM"};